var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6943 4.25296C23.5362 4.10348 23.3254 4 23.1041 4H0.885375C0.653491 4 0.453228 4.09199 0.295125 4.25296C0.115942 4.43693 0 4.6899 0 4.97735V19.5226C0 19.8101 0.115942 20.0631 0.295125 20.247C0.453228 20.3965 0.664032 20.5 0.885375 20.5H23.1041C23.336 20.5 23.5468 20.408 23.6943 20.247C23.8735 20.0631 23.9895 19.8101 23.9895 19.5341V4.96585C23.9895 4.6784 23.8735 4.42544 23.6943 4.24146V4.25296Z",
    fill: "#FE9C28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91831 12.2442L0.295125 20.2355C0.115942 20.0516 0 19.7986 0 19.5111V4.96585C0 4.67839 0.115942 4.42543 0.295125 4.24146L9.90777 12.2327L9.91831 12.2442Z",
    fill: "#FEBD00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 4.96585V19.5111C24 19.7871 23.884 20.0516 23.7049 20.224L14.0817 12.2328L23.6943 4.25296C23.8735 4.43693 23.9894 4.68989 23.9894 4.97735L24 4.96585Z",
    fill: "#FEBD00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6944 4.25296L14.0817 12.2443L12.6061 13.4746C12.2477 13.785 11.7523 13.785 11.3834 13.4746L9.90781 12.2443L0.295166 4.25296C0.453269 4.10348 0.664072 4 0.885416 4H23.1041C23.336 4 23.5363 4.09199 23.6944 4.25296Z",
    fill: "#FFD734"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.b12e15493be33c4de8b38bb0a4eef5c1.svg";
export { ForwardRef as ReactComponent };